"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorAddedEventArgs = void 0;
const EventType_1 = require("../EventType");
class ActorAddedEventArgs {
    constructor(args) {
        this.args = args;
        this.__type = EventType_1.EventType.ActorAdded;
        this.__typeName = "ActorAdded";
    }
}
exports.ActorAddedEventArgs = ActorAddedEventArgs;
